<style>
.bg-primary {
  background-color: #1a3665 !important;
}
.bg-active {
  background-color: #3e5d92;
}
.bg-subactive {
  background-color: #486ba7;
}
table td input {
  position: absolute;
  display: block;
  top: 0;
  left: 0;
  margin: 0;
  height: 100%;
  width: 100%;
  border: none;
  box-sizing: border-box;
  background: none;
  text-align: center;
}
table td {
  position: relative;
}
</style>
<template>
  <CCard>
      <CCardHeader class="bg-primary text-white d-flex align-items-center font-weight-bold">
      Riwayat Edit KAP
      <Button
        class="btn btn-md btn-dark px-4 py-2 ml-auto text-white"
        @click="$router.go(-1)"
      >Kembali</Button>
    </CCardHeader>
    <CCardBody>
      <CRow>
        <CCol xl="12">
          <CSelect
            label="Data Perhalaman"
            class="float-left"
            @change="changePageSize"
            :options="[10, 25, 100, 'Semua Data']"
          />
          <CInput
            label="Pencarian"
            class="float-right"
            placeholder="Cari Data .."
            v-model="search"
          />
          <br />
        </CCol>
      </CRow>
      <CRow>
        <CCol lg="12" class="table-responsive">
            <CDataTable style="widht:100% !important" :items="items" :fields="fields" hover sorter>
                <template #no="{index,item}">
                  <td class="py-2" :style="item.status_aktif == '1' ? 'background:#4caf50;color:white' : ''">{{index + 1}}</td>
                </template>          
                <template #tanggal_izin_kap="{item}">
                  <td class="py-2" :style="item.status_aktif == '1' ? 'background:#4caf50;color:white' : ''">{{ item.tanggal_izin_kap | moment }}</td>
                </template>
                <template #tanggal_ubah="{item}">
                  <td class="py-2" :style="item.status_aktif == '1' ? 'background:#4caf50;color:white' : ''">{{ item.tanggal_ubah | moment }}</td>
                </template>
                <template #status="{item}">
                  <td class="py-2 text-center" :style="item.status_aktif == '1' ? 'background:#4caf50;color:white' : ''">
                      <font-awesome-icon icon="check" class="text-success" v-if="item.status == 1" />
                      <font-awesome-icon icon="times" class="text-danger" v-else />
                  </td>
                </template>
                <template #nama_kap="{item}">
                  <td :style="item.status_aktif == '1' ? 'background:#4caf50;color:white' : ''">
                    {{ item.nama_kap }}
                  </td>
                </template>
                <template #no_izin="{item}">
                  <td :style="item.status_aktif == '1' ? 'background:#4caf50;color:white' : ''">
                    {{ item.no_izin }}
                  </td>
                </template>
                <template #nama_kota_kab="{item}">
                  <td :style="item.status_aktif == '1' ? 'background:#4caf50;color:white' : ''">
                    {{ item.nama_kota_kab }}
                  </td>
                </template>
                <template #no_telephone="{item}">
                  <td :style="item.status_aktif == '1' ? 'background:#4caf50;color:white' : ''">
                    {{ item.no_telephone }}
                  </td>
                </template>

                <template #kapa="{item}">
                  <td :style="item.status_aktif == '1' ? 'background:#4caf50;color:white' : ''">
                    {{ item.kapa }}
                  </td>
                </template>
                <template #aksi="{item}">
                  <td class="py-2 text-center" :style="item.status_aktif == '1' ? 'background:#4caf50;color:white' : ''">
                    <CButton 
                      v-c-tooltip="'Detail'" 
                      :color="item.status_aktif == '1' ? '' : 'success'"
                      class="btn-sm" 
                      :style="item.status_aktif == '1' ? 'background:white' : ''"
                      @click="lihatDetail(item)"
                      square>
                      <i 
                        class="fa fa-eye" 
                        :style="item.status_aktif == '1' ? 'color:#4caf50' : 'color:white'"
                        aria-hidden="true">
                      </i>
                    </CButton>
                  </td>
                </template>
               
            </CDataTable>
            <CPagination
                style="float:right"
                :active-page.sync="currentPage"
                :pages="pagination.totalPages"
                responsive
                @click="pageChange"
            />
        </CCol>
      </CRow>
      <!-- Modal Detail -->
      <CModal
        title="Detail Riwayat KAP"        
        :show.sync="myModal"                 
        :no-close-on-backdrop="true"
        :centered="true"
        size="lg"
      >
        <template #header>
          <h6 class="modal-title h4 font-weight-bold">Detail Riwayat KAP</h6>          
        </template>
        <div class="table-responsive">
          <table class="table table-bordered">
            <tbody>
              <tr>
                <th class="w-25">Nama KAP</th>
                <th>{{ item.nama_kap }}</th>
              </tr>
              <tr>
                <th class="w-25">Nama Pengubah</th>
                <th>{{ item.name }}</th>
              </tr>
              <tr>
                <th>KAPA</th>
                <th>{{ item.kapa }}</th>
              </tr>
              <tr>
                <th>Kota / Kabupaten</th>
                <th>{{ item.nama_kota_kab }}</th>
              </tr>
              <tr>
                <th>No. Telepon</th>
                <th>{{ item.no_telephone }}</th>
              </tr>              
              <tr>
                <th>Alamat</th>
                <th>{{ item.alamat }}</th>
              </tr>              
              <tr>
                <th>Nomor Fax</th>
                <th>{{ item.nomor_fax }}</th>
              </tr>
              <tr>
                <th>Tanggal KAPA</th>
                <th>{{ item.tanggal_kapa }}</th>
              </tr>
              <tr>
                <th>Tanggal Cabut Izin</th>
                <th>{{ item.tanggal_cabut_izin }}</th>
              </tr>              
              <tr>
                <th>Tanggal Izin KAP</th>
                <th>{{ item.tanggal_ubah }}</th>
              </tr>              
              <tr>
                <th>Tanggal Ubah</th>
                <th>{{ item.tanggal_izin_kap }}</th>
              </tr>              
            </tbody>
          </table>
        </div>
        <template #footer>
          <CButton @click="myModal = false" color="danger">Tutup</CButton>          
        </template>
      </CModal>
      <!-- Modal Detail -->
    </CCardBody>
  </CCard>

</template>
<script>
import moment from 'moment';
import KapService from '../../../services/keanggotaan/kap.service';

const fields = [
  {
    key: "no",
    sorter: true,
    filter: false
  },
  {
    label: "No Izin KAP",
    key: 'no_izin',
    sorter: true,
    filter: false,
    _style: "width: 13%"
  },
   {
    label: "Nama KAP",
    key: 'nama_kap',
    sorter: true,
    filter: false,
    _style: "width: 13%"
  },  
  {
    label: "KAPA/OOA",
    key: 'kapa',
    sorter: true,
    filter: false
  },
  {
    label: "Kota/Kab",
    key: 'nama_kota_kab',
    sorter: true,
    filter: false
  },
  {
    label: "No Telepon",
    key: 'no_telephone',
    sorter: true,
    filter: false
  },
  {
    label: "Tanggal Izin KAP",
    key: 'tanggal_izin_kap',
    sorter: true,
    filter: false,
    _style: "width: 13%"
  },
  {
    label: "Tanggal Ubah",
    key: 'tanggal_ubah',
    sorter: true,
    filter: false
  },
  {
    key: "aksi",
    _style: "width:20%; text-align: center",
    sorter: false,
    filter: false
  }
];

export default {
  name: "RiwayatEditKap",
  data() {
    return {
      items: [],
      item: {},
      search: "",
      ModalRiwayatEditKap : false,      
      fileName: "Choose File...",
      fields,
      currentPage: 0,
      details: [],
      pagination: {
        totalPages: 0
      },
      no: 1,
      pageSize: 10,
      status: false,
      myModal: false,
      horizontal: { label: "col-3", input: "col-9" },
      indexed: 0,
      collapseDuration: 0,
      content: []
    };
  },

  mounted() {
    this.getData("0", 10, "default");
  }, 

  filters: {
    moment: function (date) {
      return moment(date).format('DD-MM-YYYY');
    }
  },

  watch: {
    search: function (val) {
      clearTimeout(this.timeout);
      var vm = this
      this.timeout = setTimeout(function () {      
          vm.getData("0", vm.pageSize, vm.search);
      }, 1000);
    },    
    currentPage: function (val) {
      var page = val - 1;
      this.indexed = page * 10;
      this.getData(val - 1, this.pageSize, this.search);
    },
  },

  methods: {
    lihatDetail(item) {
      this.item = item;
      this.myModal = true;
    },       

    changePageSize(e) {      
      var pageSize = "";

      if (e.target.value == "Semua Data") {
        pageSize = "500";
        this.pageSize = pageSize;
      } else {
        pageSize = e.target.value;
        this.pageSize = pageSize;
      }
      this.getData("0", pageSize, this.search);
    },

    cariData() {
      this.getData("0", this.pageSize, this.search);
    },

    pageChange() {
      this.getData(this.currentPage, this.pageSize, this.search);
    },

    getData(currentPage, pageSize, filter) {      
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });

      let idKap = this.$route.params.id_kap;

      KapService.getRiwayatKap(currentPage, pageSize, filter, idKap)
        .then(response => {
          loader.hide();                    
          this.items = response.data.data.content;                   
          this.pagination.totalPages = response.data.data.totalPages;
          this.currentPage = response.data.data.pageable.pageNumber + 1;
        })
        .catch(error => {
          loader.hide();
          // comment console console.log(error);
        });
    },      
  }
};
</script>